export class FlagExtraLite {
    constructor(
        public hash: string,
        public emoji: string,
    ) {}
  }